import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api } from "../../lib/api";
import { Image as ImageIcon, ArrowRight, Camera } from "lucide-react";

export default function Gallery() {
  const [albums, setAlbums] = useState([]);
  useEffect(() => { api.get("/gallery/albums").then((r) => setAlbums(r.data || [])); }, []);
  return (
    <div>
      <PageHero title="Gallery" subtitle="A visual archive of our conferences, workshops, and outreach programs." breadcrumbs={["Home", "Gallery"]} />
      <section className="section container-wide">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {albums.map((a, i) => (
            <FadeUp key={a.id} delay={i * 0.06}>
              <Link to={`/gallery/${a.slug}`} className="group block rounded-3xl overflow-hidden bg-white border border-brand-border/70 hover:border-brand-primary/30 shadow-[0_1px_3px_rgba(0,0,0,0.04)] hover:shadow-[0_25px_60px_-20px_rgba(0,86,166,0.3)] hover:-translate-y-1 transition-all duration-500">
                <div className="aspect-[16/11] overflow-hidden relative">
                  {a.cover_image ? (
                    <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  ) : (
                    <div className="w-full h-full bg-brand-primary-light flex items-center justify-center text-brand-primary"><ImageIcon size={48} /></div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/70 via-brand-dark/10 to-transparent" />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-white/15 backdrop-glass border border-white/30 rounded-full px-3 py-1.5 text-white text-[10px] uppercase tracking-widest font-semibold">
                    <Camera size={11} /> Album
                  </div>
                </div>
                <div className="p-6">
                  <div className="font-display font-bold text-brand-text text-xl leading-tight group-hover:text-brand-primary transition-colors">{a.title}</div>
                  {a.description && <p className="text-[14px] text-brand-muted mt-2 line-clamp-2 leading-relaxed">{a.description}</p>}
                  <div className="mt-5 inline-flex items-center gap-1.5 text-brand-primary font-semibold text-sm group-hover:gap-2.5 transition-all">Open Album <ArrowRight size={14} /></div>
                </div>
              </Link>
            </FadeUp>
          ))}
          {albums.length === 0 && <div className="col-span-full text-center text-brand-muted py-16">No albums available.</div>}
        </div>
      </section>
    </div>
  );
}
